<template>
  <div
    class="box flex h-full w-full flex-row divide-x divide-slate-200 overflow-hidden shadow-xl"
  >
    <div class="flex h-full w-64 flex-col">
      <InvoicingLeftPanel v-model:invoice="invoice" />
    </div>
    <div class="flex flex-1 flex-col divide-y">
      <div class="flex shrink-0 flex-row p-3">
        <div class="flex-1">
          <h3 class="capitalize-first text-2xl font-bold">
            {{ $t('Taxes') }}
          </h3>
        </div>
        <div class="flex shrink-0 gap-x-1">
          <BaseButton
            :icon="'chevron-left'"
            :title="$t('button.back')"
            inverse-icon-order
            size="small"
            @click="
              $router.push({
                name: 'invoice_info_route',
                params: {
                  invoice_id: invoice.id
                }
              })
            "
          />
        </div>
      </div>
      <div class="flex flex-1 flex-col gap-6 overflow-y-auto p-6">
        <div
          v-for="(group, index) in itemsWiki"
          :key="index"
          class="squircle-lg flex flex-col gap-4 rounded border p-4"
        >
          <div>
            <div class="flex flex-row items-start gap-2">
              <div
                class="text-contrast-secondary flex aspect-square w-6 shrink-0 items-center justify-center rounded-md bg-orange-300"
              >
                <FontAwesomeIcon :icon="['fal', 'sitemap']" />
              </div>
              <div>
                <h3 class="capitalize-first text-base font-semibold">
                  {{
                    `${group.type ?? ''} - ${group.city_name ?? ''} - ${group.place_name ?? ''}`
                  }}
                </h3>
              </div>
            </div>
          </div>
          <div class="flex flex-1 flex-col overflow-y-auto">
            <div
              class="grid auto-cols-fr grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3"
            >
              <ItemWikiCard
                v-for="wikiItem in group.items"
                :key="wikiItem.id"
                :wiki-item="wikiItem"
                :selected="
                  selectedItems.some((i) => i.id === wikiItem.id) ?? false
                "
                @click="() => toggleItem(wikiItem.id)"
                @refresh-wiki-items="refreshList"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="flex shrink-0 flex-row justify-end p-3">
        <BaseButton
          :title="$t('button.add')"
          icon="plus"
          :disabled="selectedItems?.length === 0"
          @click="saveInvoiceItems"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import InvoicingLeftPanel from '@/views/invoicing/show/tabs/information/components/information/InvoicingLeftPanel.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ItemWikiCard from '@/views/invoicing/show/tabs/automation/component/ItemWikiCard.vue'

export default {
  name: 'TheWikiItemsSelector',
  components: {
    ItemWikiCard,
    FontAwesomeIcon,
    InvoicingLeftPanel,
    BaseButton
  },
  props: {
    invoicing_id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      itemsWiki: [],
      invoiceItems: [],
      selectAllButton: false,
      selectedItems: []
    }
  },
  computed: {
    ...mapGetters({
      invoice: 'invoicing/getInvoice'
    })
  },
  mounted() {
    this.fetchItems()
  },
  methods: {
    ...mapActions({
      processAddItemDossiersToInvoiceAction:
        'invoicing/addItemDossiersToInvoice',
      processFetchWikiItemsAction: 'invoicing/fetchWikiItems',
      processAddWikiItemsToInvoiceAction: 'invoicing/addWikiItemsToInvoice'
    }),
    refreshList() {
      this.fetchItems()
    },
    fetchItems() {
      this.processFetchWikiItemsAction({
        invoice_id: this.invoicing_id
      }).then((response) => {
        this.itemsWiki = response.wiki_items
        this.invoiceItems =
          this.invoice?.invoice_items?.map(
            (invoice_item) => invoice_item.wiki_item_id
          ) ?? []

        this.selectedItems = []
        this.itemsWiki.forEach((group) => {
          group.items.forEach((item) => {
            if (!this.invoiceItems.includes(item.id)) {
              this.selectedItems.push({ id: item.id, quantity: 1 })
            }
          })
        })
      })
    },
    toggleItem(item_id) {
      this.selectedItems = this.toggleElementInArray(
        this.selectedItems,
        item_id
      )
    },
    toggleElementInArray(array, elementId) {
      const index = array.findIndex((el) => el.id === elementId)
      if (index !== -1) {
        array.splice(index, 1)
      } else {
        array.push({ id: elementId, quantity: 1 })
      }
      return array
    },
    saveInvoiceItems() {
      const payload = {
        id: this.invoice.id,
        items: this.selectedItems.map((item) => item.id)
      }

      this.processAddWikiItemsToInvoiceAction(payload).then((response) => {
        this.$h.toastSuccess(this.$t('toasts.items_added_to_invoice'))
        this.$router.push({
          name: 'invoice_info_route',
          params: {
            invoice_id: this.invoicing_id
          }
        })
      })
    }
  }
}
</script>
